import type { EventDto } from "../../services/ApiService";
import type { Event } from "../../types/Event";
import EventId from "../../state/EventId";

export const toEvent = (dto: EventDto): Event => ({
  id: EventId.from(dto.id),
  data: dto.data,
});
